import { Activity, TrendingDown, Trophy } from "lucide-react";
import { lazy } from "react";
import type { TabRoute } from "@/lib/routes";

export const SALES_PIPELINE_PATH = "/sales-pipeline";
const WinsTab = lazy(() => import("./WinsTab"));
const ActivityTab = lazy(() => import("./ActivityTab"));
const LostTab = lazy(() => import("./LostTab"));

export const PIPELINE_TABS: ReadonlyArray<TabRoute> = [
  { path: "wins", label: "Wins", icon: Trophy, element: <WinsTab /> },
  { path: "activity", label: "Funnel activity", icon: Activity, element: <ActivityTab /> },
  { path: "lost", label: "Lost deals", icon: TrendingDown, element: <LostTab /> },
];
